import React from 'react'
import AdminDiscountList from '../../components/AdminSideComponents/AdminDiscount/AdminDiscountList'

const AdminDiscount = () => {
  return (
    <div className="bg-[#EEF3F7] p-6">
        <AdminDiscountList/>
        
    </div>
  )
}

export default AdminDiscount;